import React, { useContext } from 'react';
import styled from 'styled-components';
import ThemeContext from '../../contexts/ThemeContext';
import {
  SectionTitle as SharedSectionTitle,
} from '../PrebookingSharedComponents';
import i18n from '../../i18n';

export { CardContainer } from '../PrebookingSharedComponents';

export const SectionTitle = styled(SharedSectionTitle)`
  @media (max-width: 768px) {
    min-width: auto;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledFieldLabel = styled.span`
  font-size: ${({ $layout }) => $layout.smallFontSize}px;
  font-weight: 500;
  color: ${({ $colors }) => $colors.secondaryColor};
  line-height: 1.2;
`;
export const FieldLabel = ({ colors: _, layout: _l, ...props }) => {
  const { colors, layout } = useContext(ThemeContext);
  return <StyledFieldLabel $colors={colors} $layout={layout} {...props} />;
};

const StyledFieldValue = styled.span`
  font-size: ${({ $layout }) => $layout.mediumFontSize}px;
  font-weight: 600;
  color: ${({ $colors }) => $colors.twilight};
  line-height: 1.4;
  word-break: break-word;
`;
export const FieldValue = ({ colors: _, layout: _l, ...props }) => {
  const { colors, layout } = useContext(ThemeContext);
  return <StyledFieldValue $colors={colors} $layout={layout} {...props} />;
};

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const getScopeTypeLabel = (type) => {
  switch (type) {
    case 'words': return i18n('translation_order_scope_words');
    case 'pages': return i18n('translation_order_scope_pages');
    // Backend unit type is 'seconds', shown as "Minutes" to users
    case 'seconds': return i18n('translation_order_scope_minutes');
    default: return '';
  }
};

const SECONDS_PER_MINUTE = 60;

// Backend stores duration scope as 'seconds' but it is shown to users as minutes.
// Convert and round to at most two decimals so a second count that isn't a whole
// number of minutes (e.g. an admin-entered 250 s) renders as a clean 4.17 instead
// of 4.166666666666667 (TUL-4989). Non-duration units pass through unchanged.
export const getDisplayScope = (unitScope, unitType) => {
  if (unitType !== 'seconds' || unitScope === null || unitScope === undefined) {
    return unitScope;
  }
  const minutes = Number(unitScope) / SECONDS_PER_MINUTE;
  if (!Number.isFinite(minutes)) {
    return unitScope;
  }
  return Math.round(minutes * 100) / 100;
};

const PREVIEWABLE_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];
const PREVIEWABLE_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

export const isPreviewableAttachment = (attachment) => {
  if (!attachment) return false;
  const filename = attachment.filename || '';
  const dot = filename.lastIndexOf('.');
  const ext = dot >= 0 ? filename.slice(dot + 1).toLowerCase() : '';
  if (ext && PREVIEWABLE_EXTENSIONS.includes(ext)) return true;
  const mime = attachment.contentType || attachment.file?.type;
  return mime ? PREVIEWABLE_MIME_TYPES.includes(mime) : false;
};
